"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _lodash = require("lodash");
var _reactBootstrap = require("react-bootstrap");
var _index = _interopRequireDefault(require("../../components/ContactModal/index"));
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a Contact Modal List
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering.fields Fields for rendering
 *
 * @returns {React.ReactElement} A Contact Modal List
 */
function ContactModalList(props) {
  var {
    ListItems,
    Title,
    TitleSize
  } = (0, _utils.extractFieldsFn)(props);
  var showSideTitle = (0, _lodash.get)(props, 'params.ColumnDirection') !== undefined;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container"
  }, !(0, _lodash.isEmpty)(Title.value) && /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center"
  }, (0, _titleHeadTag.headTagTitle)(Title, '', TitleSize.value)), showSideTitle === true && ListItems.length === 1 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    rendering: ListItems[0],
    key: ListItems[0].id,
    showSideTitle: showSideTitle,
    env: (0, _lodash.get)(props, 'params.env')
  })) : /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, (0, _lodash.map)(ListItems, eachItem => {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      sm: 12,
      md: 3,
      key: eachItem.id
    }, /*#__PURE__*/_react.default.createElement(_index.default, {
      rendering: eachItem,
      showSideTitle: showSideTitle,
      env: (0, _lodash.get)(props, 'params.env')
    }));
  })));
}
var _default = exports.default = ContactModalList;